import React, { useState } from "react";

import inceptionImage from "./inception.jpeg";
import meetGreetOneImage from "./1st_meet_n_greet.jpg";
import meetGreetTwoImage from "./2nd_meet_n_greet.jpg";
import meetGreetThreeImage from "./3rd_meet_n_greet.jpg";
import "./our_journey.css";

const journeyItems = [
  {
    title: "The Inception",
    date: "April 2024",
    description:
      "An idea ignited at the 4th PropTech Convention, at the Expo Center Lahore, to bring structure, collaboration, and technology into Pakistan's real estate ecosystem translated into the inception of The PropTech Club, a curated platform for meaningful industry engagement.",
    image: inceptionImage,
  },
  {
    title: "1st Official Meet & Greet",
    date: "September 2024",
    description:
      "The first official gathering brought together a select group of developers, investors, and industry professionals. It set the tone for closed-door discussions and high-value networking within the ecosystem.",
    image: meetGreetOneImage,
  },
  {
    title: "2nd Official Meet & Greet",
    date: "April 2025",
    description:
      "The second meetup expanded participation, introducing deeper discussions around collaboration, investment opportunities, and PropTech integration. The ecosystem began to take shape with stronger alignment among stakeholders.",
    image: meetGreetTwoImage,
  },
  {
    title: "3rd Official Meet & Greet",
    date: "April 2026",
    description:
      "By the third gathering, PropTech Club had evolved into a structured network of decision-makers. Focused conversations, curated participation, and real opportunities defined the experience.",
    image: meetGreetThreeImage,
  },
];

const OurJourney = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section id="our_journey_section">
      <div id="our_journey_intro">
        <p id="our_journey_eyebrow">Our History</p>
        <h2 id="our_journey_hdng">Our Journey</h2>
        <p id="our_journey_subhdng">
          From a single idea to a growing real estate ecosystem
        </p>
      </div>

      <div id="our_journey_timeline">
        <div id="our_journey_line" />

        {journeyItems.map((item, index) => (
          <article
            className={`our_journey_item${hoveredIndex === index ? " our_journey_item_hovered" : ""}`}
            key={item.title}
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            <button
              type="button"
              className="our_journey_node"
              onClick={() => setHoveredIndex(hoveredIndex === index ? null : index)}
              aria-expanded={hoveredIndex === index}
            >
              <div className="our_journey_visual_anchor">
                <div className="our_journey_image_pop">
                  <div className="our_journey_card_image_wrap">
                    <img className="our_journey_card_image" src={item.image} alt={item.title} />
                    <div className="our_journey_card_overlay" />
                  </div>
                </div>

                <span className="our_journey_dot" />
              </div>

              <div className="our_journey_text_block">
                <span className="our_journey_title">{item.title}</span>
                <span className="our_journey_date">{item.date}</span>
                <div className="our_journey_description_pop">
                  <p className="our_journey_card_text">{item.description}</p>
                </div>
              </div>
            </button>
          </article>
        ))}
      </div>

      <div id="our_journey_mobile_cards">
        {journeyItems.map((item, index) => (
          <article
            className={`our_journey_mobile_item${activeIndex === index ? " our_journey_mobile_item_active" : ""}`}
            key={item.title}
          >
            <button
              type="button"
              className="our_journey_mobile_trigger"
              onClick={() => setActiveIndex(index)}
              aria-expanded={activeIndex === index}
            >
              <span className="our_journey_dot our_journey_dot_mobile" />
              <span className="our_journey_mobile_title_group">
                <span className="our_journey_title">{item.title}</span>
                <span className="our_journey_date">{item.date}</span>
              </span>
            </button>

            {activeIndex === index && (
              <div className="our_journey_mobile_card">
                <div className="our_journey_card_image_wrap">
                  <img className="our_journey_card_image" src={item.image} alt={item.title} />
                  <div className="our_journey_card_overlay" />
                </div>
                <div className="our_journey_card_body">
                  <h3 className="our_journey_card_title">{item.title}</h3>
                  <p className="our_journey_card_text">{item.description}</p>
                </div>
              </div>
            )}
          </article>
        ))}
      </div>
    </section>
  );
};

export default OurJourney;
